import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {metrics} from '~/vendor/metrics';
import Notification from '~/components/Notification';
import {Button, Stack} from '@customink/pigment-react';

export const fireMetricEventFontMinHeightError = ({fontName, styleName}) => {
  if (!metrics || !fontName || !styleName) {
    return;
  }
  metrics.pageViewTag('/ndx/text/font/heighterror/');
  metrics.fireEvent('/ndx/text/font/heighterror/', [styleName, fontName]);
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export function FontMinHeightError(props) {
  const {dismiss, confirm, selectedStyle, notification} = props;

  useEffect(() => {
    fireMetricEventFontMinHeightError({
      fontName: notification?.fontName,
      styleName: selectedStyle?.name
    });
  }, [notification, selectedStyle]);

  return (
    <Notification
      {...props}
      title={
        <span>
          Would you like to resize
          <br />
          your font?
        </span>
      }>
      <p>The font that you have chosen can’t be printed at the current size.</p>
      <Stack className="notification-stack">
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={confirm}>
          Resize Font
        </Button>
        <Button
          size="large"
          variant="link"
          className="notification-cta"
          onClick={dismiss}>
          Choose a Different Font
        </Button>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  confirm: PropTypes.func,
  dismiss: PropTypes.func,
  notification: PropTypes.object,
  selectedStyle: PropTypes.object
};

FontMinHeightError.propTypes = propTypes;

FontMinHeightError.displayName = 'FontMinHeightError';

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import {getAnchorStyle} from '~/selectors/ProductSelectors';
import {confirm, dismiss} from '~/actions/NotificationActions';

function select(state) {
  return createStructuredSelector({
    selectedStyle: getAnchorStyle
  })(state);
}

function actions(dispatch) {
  return bindActionCreators(
    {
      confirm,
      dismiss
    },
    dispatch
  );
}

export default connect(select, actions)(FontMinHeightError);
